import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSlideshow } from './useSlideshow';
import { useSwipe } from './useSwipe';
import Slide from './Slide';
import CallToAction from './CallToAction';
import QuoteModal from '../Quote/QuoteModal';

const Slideshow = ({ slides }) => {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const { current, navigate, indicators } = useSlideshow(slides.length);
  
  const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe(
    () => navigate('next'),
    () => navigate('prev')
  );

  return (
    <section 
      className="relative h-[90vh] overflow-hidden"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* Navigation Arrows - Desktop Only */}
      <div className="absolute inset-0 z-20 hidden md:flex items-center justify-between px-4">
        <button
          onClick={() => navigate('prev')}
          className="p-2 rounded-full bg-black/30 hover:bg-black/50 text-white transition-colors duration-300"
          aria-label="Previous slide"
        >
          <ChevronLeft className="w-8 h-8" />
        </button>
        <button
          onClick={() => navigate('next')}
          className="p-2 rounded-full bg-black/30 hover:bg-black/50 text-white transition-colors duration-300"
          aria-label="Next slide"
        >
          <ChevronRight className="w-8 h-8" />
        </button>
      </div>

      {/* Slides */}
      {slides.map((slide, index) => (
        <Slide
          key={index}
          {...slide}
          isActive={current === index}
          isNext={Math.abs(current - index) <= 1}
        />
      ))}

      {/* Call to Action */}
      <CallToAction onQuoteClick={() => setIsQuoteModalOpen(true)} />

      {/* Mover Badge */}
      <a 
        href="https://www.localmovers.com/movers-in-raleigh"
        className="absolute bottom-9 right-20 z-20"
      >
        <img
          src="/images/mover-badge.jpg"
          alt="Mover Badge"
          className="w-16 h-16 md:w-40 md:h-40"
        />
      </a>

      {/* Slide Indicators */}
      <div className="absolute inset-x-0 bottom-8 z-10">
        <div className="flex justify-center space-x-2">
          {indicators.map((isActive, index) => (
            <button
              key={index}
              onClick={() => navigate('goto', index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                isActive ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </section>
  );
};

export default Slideshow;